/**
 * Created by zhaoy on 2022/10/21
 * Desc: 话机话费预存
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Avatar } from 'antd'
import { Toast, Modal } from 'antd-mobile'
import { isObjEmpty, NoToChinese } from '../../utils/common'
import './PayableCost.css'
import { fetchGet, fetchPost } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'

const {alert} = Modal

class PayableCost extends Component {

    constructor() {
        super()

        this.state = {
            balance: '0',
            payment: '0',
            endDate: '',
            explain: '',
            rechargeList: [],
        }
    }

    componentDidMount() {
        document.title = '话费预存'

        Toast.loading('', 0)
        this.getServiceList()
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const { stu, stuPhoto, stuName, userInfo } = this.props
        const {
            balance,
            payment,
            endDate,
            explain,
            rechargeList,
        } = this.state

        const rechargeItems = []
        rechargeList.forEach((rechargeObj, index) => {
            rechargeItems.push(<div className='service-content-layout1'>
                <div
                    className='service-content-item'
                    onClick={this.onCallClick.bind(this, index,
                        rechargeObj.ruleId)}>
                    <span className='service-content-item-text'>{rechargeObj.yearsMany}</span>
                    <span className='service-content-item-text'>¥ {rechargeObj.ruleAmount}</span>
                </div>
                {/*}*/}
            </div>)
        })

        return (
            <div id='info-service-root'>
                {/*头部-个人信息*/}
                <div className='info-service-head bg_light_green'>
                    {isObjEmpty(stuPhoto)
                        ? <Avatar size={64} icon='user' />
                        :
                        <Avatar size={64} src={stuPhoto} />}
                    <div className="text_white span_16 margin_top_5">{stuName}</div>
                    {this.state.balance <= 0 ? <div className="text_white span_19">余额: 0元</div> :
                        <div className="text_white span_19">余额: {this.state.balance}元</div>
                    }
                </div>
                <div
                    className='head-stu-info-layout bg_light_green_transparent'>
                    <div style={{ flex: 1 }}>入学日期:{stu.stuEnrollDate}</div>
                    <div style={{ flex: 1 }}>年级:{userInfo.parent.student.stuGrade}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{payment == '1' ? '使用中' : <span className="color_red">未使用</span>}</div>
                </div>
                <div id='info-service-body'>
                    {/*服务内容*/}
                    <span className='service-content-title'>电话预存说明</span>
                    <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: this.state.explain }} /></span>

                    {/*信息费列表*/}
                    <span className='service-content-title'>电话费用（元）</span>
                    <div style={{ marginTop: '6px' }}>{rechargeItems}</div>
                    <div
                        style={{
                            textAlign: 'center',
                            margin: '40px 10px 20px 0px',
                        }}>
                        <span style={{
                            color: 'blue',
                            fontSize: '16px',
                            borderBottom: '1px solid blue',
                            fontWeight: '600',
                        }}
                            onClick={this.toCallRecord}>历史预付记录</span>
                    </div>
                </div>
            </div>
        )
    }

    getServiceList = () => {
        const { studentId, schoolId, stuGradeId } = this.props
        let { rechargeList } = this.state
        rechargeList.length = 0
        fetchGet(API.INFO_CALL_SERVICE_LIST, {
            studentId,
            schoolId,
            stuGradeId: stuGradeId,
        }).then(response => {
            Toast.hide()
            if (response && response.data && response.data.rulesList &&
                response.data.rulesList.length > 0) {
                rechargeList = response.data.rulesList
            }
            this.setState({
                rechargeList,
                isLoading: false,
                endDate: response.data.endDate,
                //balance: response.data.balance,
                payment: response.data.callState,
                explain: response.data.explain,
            }, () => {
                console.log(rechargeList)
            })
        }).catch(error => {
            Toast.hide()

            this.setState({
                rechargeList,
            })
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    onCallClick = (index, ruleId) => {
        alert('', '已阅读同意上述服务条款', [
            {
                text: '取消', onPress: () => { }
            },
            {
                text: '确定', onPress: () => {
                        this.wxPayCallRequest(ruleId)
                }
            }
        ])
    }

    toCallRecord = () => {
        this.props.history.push('/payableCostRecord')
    }

    wxPayCallRequest = (ruleId) => {
        let err = ''
        Toast.loading('')
        let openId = ''
        if (typeof this.props.userOpenid == 'undefined' ||
            this.props.userOpenid == null || this.props.userOpenid == '') {
            Toast.fail('openId为空，请退出重新进入应用')
            return
        } else {
            openId = this.props.userOpenid
        }

        fetchPost(API.INFO_CALL_SERVICE_ORDER, {
            openId: openId,
            ruleId: ruleId,
            studentId: this.props.userInfo.parent.student.stuId,
            parentId: this.props.userInfo.parent.parentId,
            appId: this.props.userInfo.appId,
        }).then((response) => {
            Toast.hide()
            const data = response.data
            err = data
            if (err === undefined) {
                err = response.message;
            }
            if (typeof WeixinJSBridge == 'undefined') {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady',
                        this.onBridgeReady(data), false)
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady',
                        this.onBridgeReady(data))
                    document.attachEvent('onWeixinJSBridgeReady',
                        this.onBridgeReady(data))
                }
            } else {
                this.onBridgeReady(data)
            }
        }).catch((error) => {
            console.log('error:' + JSON.stringify(error))
            Toast.show('支付失败！' + error)
        })

    }

    onBridgeReady = (json) => {
        console.log('json:', json)
        const that = this
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', JSON.parse(json),
            function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    Toast.success('支付成功！')
                    // that.props.history.push('/payResult/' + that.state.amount)
                } else {
                    Toast.fail('支付失败！')
                    // message.info("支付失败:" + res.err_msg)
                    // that.setState({
                    //     payInfo: json,
                    //     payResult: "支付失败:" + JSON.stringify(res)
                    // });
                }
            })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo },
    appId: state.redUserInfo.appId,
    studentId: state.redUserInfo.parent.student.stuId,
    stuGradeId: state.redUserInfo.parent.student.stuGradeId,
    schoolId: state.redUserInfo.user.schoolId,
    stu: state.redUserInfo.parent.student,
    userOpenid: state.redUserInfo.userOpenid,
    stuPhoto: state.redUserInfo.parent.student
        ? state.redUserInfo.parent.student.stuPhoto
        : '',
    stuName: state.redUserInfo.parent.student
        ? state.redUserInfo.parent.student.stuName
        : '',
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PayableCost)
